export const authenticated = (state) => {
  return state.authenticated
}

export const user = (state) => {
  return state.user
}



// WEBPACK FOOTER //
// ./src/store/modules/auth/getters.js